module.exports = __webpack_public_path__ + "img/xxnl-banner2.c1ea54f7.png";